var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25163 10.7866C3.52415 8.45144 3.92233 6.70054 4.2916 5.45662C4.5944 4.43664 4.74579 3.92665 5.36665 3.46332C5.9875 3 6.62209 3 7.89126 3H12.1087C13.3779 3 14.0125 3 14.6334 3.46332C15.2542 3.92665 15.4057 4.43664 15.7084 5.45662C16.0777 6.70054 16.4759 8.45144 16.7484 10.7866C17.0696 13.5387 17.2302 14.9147 16.3021 15.9573C15.3741 17 13.8701 17 10.8621 17H9.13793C6.12995 17 4.62596 17 3.69791 15.9573C2.76986 14.9147 2.93045 13.5387 3.25163 10.7866Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 6.11108C7.66675 7.39975 8.7114 8.44442 10.0001 8.44442C11.2887 8.44442 12.3334 7.39975 12.3334 6.11108",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchaseOrder.76eb4fc11095e8429f0ebb6d288bb3a0.svg";
export { ForwardRef as ReactComponent };